export interface ISimilarSearchModel {
  //pageNumber: number;
  //itemsPerPage: number;

  derivativeId: number;
  derivativeType: string;
  countryCode: string;

}
export class SimilarSearchModel implements ISimilarSearchModel {
  constructor(
    public derivativeId: number,
    public derivativeType: string,
    public countryCode: string,
  ) { }

  public static empty() {
    return new SimilarSearchModel(0, '', '');
  }
}
